module.exports = __webpack_public_path__ + "static/media/union.d6b40254.png";